var PageName = /*@__PURE__*/(function (PageName = {}) {
    PageName["BookingConfirmed"] = "Booking Confirmed";
    PageName["BookingIframe"] = "Booking Iframe";
    PageName["Calendar"] = "Calendar";
    PageName["Homepage"] = "Index";
    PageName["Packages"] = "Packages";
    PageName["RoomsAndRates"] = "Rooms and Rates";
    PageName["UserRegisterPage"] = "User Register Page";
    return PageName;
})(PageName);
const SET_PAGE_NAME_VAR = '__thn_page_name';

var LanguageCode = /*@__PURE__*/(function (LanguageCode = {}) {
    LanguageCode["Abkhazian"] = "ab";
    LanguageCode["Afar"] = "aa";
    LanguageCode["Afrikaans"] = "af";
    LanguageCode["Akan"] = "ak";
    LanguageCode["Albanian"] = "sq";
    LanguageCode["Amharic"] = "am";
    LanguageCode["Arabic"] = "ar";
    LanguageCode["Aragonese"] = "an";
    LanguageCode["Armenian"] = "hy";
    LanguageCode["Assamese"] = "as";
    LanguageCode["Avaric"] = "av";
    LanguageCode["Avestan"] = "ae";
    LanguageCode["Aymara"] = "ay";
    LanguageCode["Azerbaijani"] = "az";
    LanguageCode["Bambara"] = "bm";
    LanguageCode["Bashkir"] = "ba";
    LanguageCode["Basque"] = "eu";
    LanguageCode["Belarusian"] = "be";
    LanguageCode["Bengali"] = "bn";
    LanguageCode["Bihari"] = "bh";
    LanguageCode["Bislama"] = "bi";
    LanguageCode["Bosnian"] = "bs";
    LanguageCode["Breton"] = "br";
    LanguageCode["Bulgarian"] = "bg";
    LanguageCode["Burmese"] = "my";
    LanguageCode["Catalan"] = "ca";
    LanguageCode["Chamorro"] = "ch";
    LanguageCode["Chechen"] = "ce";
    LanguageCode["Chewa"] = "ny";
    LanguageCode["Chinese"] = "zh";
    LanguageCode["ChineseTraditional"] = "zh_TW";
    LanguageCode["Chuvash"] = "cv";
    LanguageCode["Cornish"] = "kw";
    LanguageCode["Corsican"] = "co";
    LanguageCode["Cree"] = "cr";
    LanguageCode["Croatian"] = "hr";
    LanguageCode["Czech"] = "cs";
    LanguageCode["Danish"] = "da";
    LanguageCode["Divehi"] = "dv";
    LanguageCode["Dutch"] = "nl";
    LanguageCode["Dzongkha"] = "dz";
    LanguageCode["English"] = "en";
    LanguageCode["Esperanto"] = "eo";
    LanguageCode["Estonian"] = "et";
    LanguageCode["Ewe"] = "ee";
    LanguageCode["Faroese"] = "fo";
    LanguageCode["Fijian"] = "fj";
    LanguageCode["Finnish"] = "fi";
    LanguageCode["French"] = "fr";
    LanguageCode["Fula"] = "ff";
    LanguageCode["Galician"] = "gl";
    LanguageCode["Georgian"] = "ka";
    LanguageCode["German"] = "de";
    LanguageCode["Greek"] = "el";
    LanguageCode["Greenlandic"] = "gn";
    LanguageCode["Gujarati"] = "gu";
    LanguageCode["Haitian"] = "ht";
    LanguageCode["Hausa"] = "ha";
    LanguageCode["Hebrew"] = "he";
    LanguageCode["Herero"] = "hz";
    LanguageCode["Hindi"] = "hi";
    LanguageCode["Hiri"] = "ho";
    LanguageCode["Hungarian"] = "hu";
    LanguageCode["Interlingua"] = "ia";
    LanguageCode["Indonesian"] = "id";
    LanguageCode["Interlingue"] = "ie";
    LanguageCode["Irish"] = "ga";
    LanguageCode["Igbo"] = "ig";
    LanguageCode["Inupiaq"] = "ik";
    LanguageCode["Ido"] = "io";
    LanguageCode["Icelandic"] = "is";
    LanguageCode["Italian"] = "it";
    LanguageCode["Inuktitut"] = "iu";
    LanguageCode["Japanese"] = "ja";
    LanguageCode["Javanese"] = "jv";
    LanguageCode["Kalaallisut"] = "kl";
    LanguageCode["Kannada"] = "kn";
    LanguageCode["Kanuri"] = "kr";
    LanguageCode["Kashmiri"] = "ks";
    LanguageCode["Kazakh"] = "kk";
    LanguageCode["Khmer"] = "km";
    LanguageCode["Kikuyu"] = "ki";
    LanguageCode["Kinyarwanda"] = "rw";
    LanguageCode["Kirghiz"] = "ky";
    LanguageCode["Komi"] = "kv";
    LanguageCode["Kongo"] = "kg";
    LanguageCode["Korean"] = "ko";
    LanguageCode["Kurdish"] = "ku";
    LanguageCode["Kuanyama"] = "kj";
    LanguageCode["Latin"] = "la";
    LanguageCode["Luxembourgish"] = "lb";
    LanguageCode["Ganda"] = "lg";
    LanguageCode["Limburgish"] = "li";
    LanguageCode["Lingala"] = "ln";
    LanguageCode["Lao"] = "lo";
    LanguageCode["Lithuanian"] = "lt";
    LanguageCode["Luba"] = "lu";
    LanguageCode["Latvian"] = "lv";
    LanguageCode["Manx"] = "gv";
    LanguageCode["Macedonian"] = "mk";
    LanguageCode["Malagasy"] = "mg";
    LanguageCode["Malay"] = "ms";
    LanguageCode["Malayalam"] = "ml";
    LanguageCode["Maltese"] = "mt";
    LanguageCode["Maori"] = "mi";
    LanguageCode["Marathi"] = "mr";
    LanguageCode["Marshallese"] = "mh";
    LanguageCode["Mongolian"] = "mn";
    LanguageCode["Nauru"] = "na";
    LanguageCode["Navajo"] = "nv";
    LanguageCode["NorthNdebele"] = "nd";
    LanguageCode["Nepali"] = "ne";
    LanguageCode["Ndonga"] = "ng";
    LanguageCode["NorwegianBokmal"] = "nb";
    LanguageCode["NorwegianNynorsk"] = "nn";
    LanguageCode["Norwegian"] = "no";
    LanguageCode["Nuosu"] = "ii";
    LanguageCode["SouthNdebele"] = "nr";
    LanguageCode["Occitan"] = "oc";
    LanguageCode["Ojibwe"] = "oj";
    LanguageCode["Old"] = "cu";
    LanguageCode["Oromo"] = "om";
    LanguageCode["Oriya"] = "or";
    LanguageCode["Ossetian"] = "os";
    LanguageCode["Panjabi"] = "pa";
    LanguageCode["Pali"] = "pi";
    LanguageCode["Persian"] = "fa";
    LanguageCode["Polish"] = "pl";
    LanguageCode["Pashto"] = "ps";
    LanguageCode["Portuguese"] = "pt";
    LanguageCode["Quechua"] = "qu";
    LanguageCode["Romansh"] = "rm";
    LanguageCode["Rundi"] = "rn";
    LanguageCode["Romanian"] = "ro";
    LanguageCode["Russian"] = "ru";
    LanguageCode["Sanskrit"] = "sa";
    LanguageCode["Sardinian"] = "sc";
    LanguageCode["Sindhi"] = "sd";
    LanguageCode["Northern"] = "se";
    LanguageCode["Samoan"] = "sm";
    LanguageCode["Sango"] = "sg";
    LanguageCode["Serbian"] = "sr";
    LanguageCode["Scottish"] = "gd";
    LanguageCode["Shona"] = "sn";
    LanguageCode["Sinhala"] = "si";
    LanguageCode["Slovak"] = "sk";
    LanguageCode["Slovene"] = "sl";
    LanguageCode["Somali"] = "so";
    LanguageCode["Sotho"] = "st";
    LanguageCode["Spanish"] = "es";
    LanguageCode["Sundanese"] = "su";
    LanguageCode["Swahili"] = "sw";
    LanguageCode["Swati"] = "ss";
    LanguageCode["Swedish"] = "sv";
    LanguageCode["Tamil"] = "ta";
    LanguageCode["Telugu"] = "te";
    LanguageCode["Tajik"] = "tg";
    LanguageCode["Thai"] = "th";
    LanguageCode["Tigrinya"] = "ti";
    LanguageCode["Tibetan"] = "bo";
    LanguageCode["Turkmen"] = "tk";
    LanguageCode["Tagalog"] = "tl";
    LanguageCode["Tswana"] = "tn";
    LanguageCode["Tonga"] = "to";
    LanguageCode["Turkish"] = "tr";
    LanguageCode["Tsonga"] = "ts";
    LanguageCode["Tatar"] = "tt";
    LanguageCode["Twi"] = "tw";
    LanguageCode["Tahitian"] = "ty";
    LanguageCode["Uighur"] = "ug";
    LanguageCode["Ukrainian"] = "uk";
    LanguageCode["Urdu"] = "ur";
    LanguageCode["Uzbek"] = "uz";
    LanguageCode["Venda"] = "ve";
    LanguageCode["Vietnamese"] = "vi";
    LanguageCode["Volapuk"] = "vo";
    LanguageCode["Walloon"] = "wa";
    LanguageCode["Welsh"] = "cy";
    LanguageCode["Wolof"] = "wo";
    LanguageCode["Western"] = "fy";
    LanguageCode["Xhosa"] = "xh";
    LanguageCode["Yiddish"] = "yi";
    LanguageCode["Yoruba"] = "yo";
    LanguageCode["Zhuang"] = "za";
    LanguageCode["Zulu"] = "zu";
    return LanguageCode;
})(LanguageCode);
var SearchPriceSpecial = /*@__PURE__*/(function (SearchPriceSpecial = {}) {
    /**
     * The cheapest normal available price (usually would be the BAR).
     */
    SearchPriceSpecial[SearchPriceSpecial["None"] = 0] = "None";
    /**
     * Any other thing that it is not the cheapest "normal" available price.
     * Id est, anthing that is sensitive to produces a _not real_ disparity.
     */
    SearchPriceSpecial[SearchPriceSpecial["Generic"] = 1] = "Generic";
    /**
     * The price is special because it is influenced by discount.
     */
    SearchPriceSpecial[SearchPriceSpecial["Discount"] = 2] = "Discount";
    return SearchPriceSpecial;
})(SearchPriceSpecial);
var SearchPriceType = /*@__PURE__*/(function (SearchPriceType = {}) {
    /**
     * The price amount does not include taxes.
     */
    SearchPriceType["WithoutTaxes"] = "base";
    /**
     * The price amount does include taxes.
     */
    SearchPriceType["WithTaxes"] = "full";
    return SearchPriceType;
})(SearchPriceType);
var RoomKind = /*@__PURE__*/(function (RoomKind = {}) {
    RoomKind["Standard"] = "standard";
    RoomKind["Superior"] = "superior";
    RoomKind["Suite"] = "suite";
    return RoomKind;
})(RoomKind);

export { LanguageCode as L, PageName as P, RoomKind as R, SearchPriceSpecial as S, SET_PAGE_NAME_VAR as a, SearchPriceType as b };
